import { useEffect, useState } from 'react'
import type { OrderStatus } from '@/types/enums'
import { isTerminalStatus } from '@/utils/status-transitions'
import {
  elapsedInStatusMs,
  formatElapsedActiveHoursMinutes,
  formatElapsedSearch,
  formatMoscowDateOnly,
  isOverdue,
} from '@/utils/format'

export function LiveTimer({
  status,
  createdAt,
  statusUpdatedAt,
  size = 'default',
}: {
  status: OrderStatus
  createdAt: string
  statusUpdatedAt: string
  size?: 'default' | 'display'
}) {
  const terminal = isTerminalStatus(status)
  const [, setT] = useState(0)
  useEffect(() => {
    if (terminal) return
    const id = window.setInterval(() => setT((x) => x + 1), 1000)
    return () => window.clearInterval(id)
  }, [terminal])

  const monoFamily =
    'font-[family-name:var(--stryzh-font-family-mono)] tracking-[var(--stryzh-letter-spacing-mono)]'
  const monoSize =
    size === 'display'
      ? 'text-[length:var(--stryzh-font-size-display)] font-semibold'
      : 'text-[length:var(--stryzh-font-size-base)]'

  if (terminal) {
    return (
      <span
        className={`${monoFamily} ${monoSize} text-[color:var(--stryzh-color-text-primary)]`}
      >
        {formatMoscowDateOnly(statusUpdatedAt)}
      </span>
    )
  }

  const overdue = isOverdue(status, createdAt, statusUpdatedAt)
  const ms = elapsedInStatusMs(status, createdAt, statusUpdatedAt)
  const text =
    status === 'SEARCH'
      ? formatElapsedSearch(ms)
      : formatElapsedActiveHoursMinutes(ms)

  return (
    <span
      className={
        overdue
          ? `${monoFamily} ${monoSize} stryzh-mono-timer--critical`
          : `${monoFamily} ${monoSize} stryzh-mono-timer`
      }
    >
      {text}
    </span>
  )
}
